/* eslint-disable no-shadow */
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as eventProfileActions from '../../../../../actions/event-profile-actions';
import EventPostScorePopup from '../../../../../components/PopUps/EventPostScorePopup';
import { EventProfileMatchCardMenuOptions } from '../../../../../utils/constants';
import { canPostScoreInEventProfile, getScheduleInfoForMatch } from '../../../../../utils/matchCardUtils';
import { normalizeMatchPositionsForPostScore } from '../../../../../utils/postScore';
import EventProfileMatchCard from '../EventProfileMatchCard';

const { EDIT_SCORE, DELETE_SCORE } = EventProfileMatchCardMenuOptions;

const OrderOfPlayCourt = (props) => {
    const { court, columnNumber } = props;
    const { event, draws } = useSelector(({ eventProfile }) => {
        const { event, draws } = eventProfile;
        return { event, draws };
    });
    const dispatch = useDispatch();
    const [postScore, setPostScore] = useState({ showModal: false, selectedMatchId: null });

    const { drawsDict } = draws;
    const postScoreEnabled = canPostScoreInEventProfile(event.data);

    const handleClearScore = async (match) => {
        try {
            await dispatch(eventProfileActions.clearScore(match, match.drawId)); // NOSONAR — Redux thunk returns a promise
        } catch (err) {
            console.error('clearScore failed', err);
        }
    };

    const handleMatchCardMenuSelect = (menuOption, match) => {
        if (menuOption.id === EDIT_SCORE.id) {
            setPostScore({ showModal: true, selectedMatchId: match?.id });
        } else if (menuOption.id === DELETE_SCORE.id) {
            handleClearScore(match);
        } else {
            // Other menu options not handled here
        }
    };

    const handlePostScoreClick = (match) => {
        setPostScore({ showModal: true, selectedMatchId: match?.id });
    };

    const matchToLastTimedMatchMap = useMemo(() => {
        let lastTimedMatchId = null;
        return court.matches.reduce((map, match) => {
            map[match.matchId] = lastTimedMatchId;
            const hasDate = match.matchDetails?.date;
            if (hasDate) {
                if (match.includesTime && !match.notBefore) {
                    lastTimedMatchId = match.matchId;
                } else if (match.notBefore && !lastTimedMatchId) {
                    lastTimedMatchId = match.matchId;
                } else {
                    // no need to be handled
                }
            }

            return map;
        }, {});
    }, [court.matches]);

    const matchesForPostScore = useMemo(
        () => court.matches.map((scheduleMatch) => scheduleMatch.matchDetails).map(normalizeMatchPositionsForPostScore),
        [court.matches],
    );

    const matchIndex = useMemo(() => {
        if (postScore.selectedMatchId == null) {
            return -1;
        }
        return court.matches.findIndex(
            (scheduleMatch) => scheduleMatch.matchId === postScore.selectedMatchId,
        );
    }, [court.matches, postScore.selectedMatchId]);

    return (
        <>
            <div className={`col-12 col-md-4 d-md-block round${columnNumber}`}>
                <div className="section-header text-small text-medium text-center text-dark mb24">
                    {court?.name}
                </div>
                <div className="spacer" />
                {court.matches.filter(item => item.matchDetails?.isDrawPublished !== false).map((item, i) => {
                    const draw = drawsDict[item.matchDetails?.drawId];

                    return (
                        <EventProfileMatchCard
                            key={`match-${item.matchDetails?.id}-${i}`}
                            match={item.matchDetails}
                            scheduleInfo={getScheduleInfoForMatch(item)}
                            matchToLastTimedMatchMap={matchToLastTimedMatchMap}
                            draw={draw}
                            event={event.data}
                            postScoreEnabled={postScoreEnabled}
                            onPostScoreClick={handlePostScoreClick}
                            onMatchCardMenuSelect={handleMatchCardMenuSelect}
                            showFacilityCourtInfo={false}
                            showMatchDate={false}
                            showDrawName={true}
                            showRoundLevel={false}
                        />
                    );
                })}
            </div>
            {postScore.showModal && postScore.selectedMatchId != null && matchIndex >= 0 && (
                <EventPostScorePopup
                    event={event.data}
                    drawsDict={drawsDict}
                    draw={drawsDict[matchesForPostScore[matchIndex]?.drawId]}
                    matchIndex={matchIndex}
                    matches={matchesForPostScore}
                    onCloseClick={() => setPostScore({ showModal: false, selectedMatchId: null })}
                    postScoreAction={eventProfileActions.postScore}
                />
            )}
        </>
    );
};

export default OrderOfPlayCourt;
